/**
 * @generated SignedSource<<4f2d3edb730e375a0e561451a067e322>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InputTagsSelect_tenant$data = {
  readonly tags: ReadonlyArray<{
    readonly dId: any | null;
    readonly " $fragmentSpreads": FragmentRefs<"TagTag_tag">;
  }>;
  readonly " $fragmentType": "InputTagsSelect_tenant";
};
export type InputTagsSelect_tenant$key = {
  readonly " $data"?: InputTagsSelect_tenant$data;
  readonly " $fragmentSpreads": FragmentRefs<"InputTagsSelect_tenant">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InputTagsSelect_tenant",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TagNode",
      "kind": "LinkedField",
      "name": "tags",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dId",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TagTag_tag"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TenantNode",
  "abstractKey": null
};

(node as any).hash = "a489b9eb7a989ed9e12a70e09a4cc6a3";

export default node;
